/* MONOREE: route Shopify Standard Actions through the same mutation FIFO as
 * product forms and cart quantities. This does not wrap fetch or payment APIs. */
async function refreshDawnCartUI() {
  if (!window.MonoreeCart) throw new Error('Cart queue could not be loaded');
  return window.MonoreeCart.enqueue(() => window.MonoreeCart.refresh());
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions || window.monoreeStandardActionsInstalled) return;
  if (typeof actions.openCart?.configure !== 'function' || typeof actions.updateCart?.configure !== 'function') return;
  window.monoreeStandardActionsInstalled = true;
  actions.openCart.configure({
    async handler(defaultHandler) {
      await window.MonoreeCart?.whenIdle();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      return defaultHandler();
    },
  });
  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      if (!window.MonoreeCart) throw new Error('Cart queue could not be loaded');
      return window.MonoreeCart.enqueue(async () => {
        let timer;
        try {
          const result = await Promise.race([
            Promise.resolve().then(defaultHandler),
            new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Cart update timed out')), 30000); }),
          ]);
          clearTimeout(timer);
          await window.MonoreeCart.refresh();
          return result;
        } catch (error) {
          // Never repeat a failed/uncertain mutation: its server-side effect is unknown.
          window.MonoreeCart.block(error);
          window.location.assign(window.routes?.cart_url || '/cart');
          throw error;
        } finally { clearTimeout(timer); }
      });
    },
  });
}
if (window.Shopify?.actions) initStandardActions();
else document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
